export const getMobileOperators = () => {
  return {
    type: 'FETCH_MOBILEOPERATORS',
    payload: {
      client: 'cloudloyalty',
      request: {
        method: 'get',
        url: `/v1/mobileRecharges/mobileoperator`
      }
    }
  }
}
export default {
  getMobileOperators
}



// WEBPACK FOOTER //
// ./src/features/SelectMobileOperator/actions.js